import React from 'react';
import PackagesPage from 'components/PackagesPage';

const MemberPage = () => {
  return (
    <div>
      <PackagesPage
        category={'member'}
        messageID={'pages.pack.memberPage'}
        descriptionID={'pages.pack.memberPage.description'}
      />
    </div>
  );
};

export default MemberPage;
